var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcInfo = function SvgIcInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_info_svg__clip0_673_8151)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#EFF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.949 7.71v6.869H9.114V7.71h1.835ZM9 5.92c0-.266.093-.486.28-.66.185-.173.435-.26.748-.26.31 0 .557.087.743.26.19.174.286.394.286.66a.854.854 0 0 1-.286.66c-.186.174-.434.26-.743.26-.313 0-.563-.086-.749-.26A.863.863 0 0 1 9 5.92Z",
    fill: "#606367"
  }))));
};
export default SvgIcInfo;